import ReactDOM from "react-dom/client";
// import reportWebVitals from "./reportWebVitals";
import "./sass/style.scss";
import PackageBuilderWrapper from "components/PageWrapper/PackageBuilderWrapper";

/*
  This entry point is for packaging only.
*/

import PackageBuilderPage from "views/GradeManagement/GradeManagement"; // npm run build:package:grade-management

export const packagingPrefix = "build-package-";
/* this must be set to true when packaging */
export const isPackaged: Boolean = true;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <PackageBuilderWrapper>
    <PackageBuilderPage />
  </PackageBuilderWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
